module.exports = __webpack_public_path__ + "img/rule-SEBG.8c53f425.svg";